// extracted by mini-css-extract-plugin
export default {"Wrapper":"CaseStudyFilterOption_Wrapper__+lxIj","Icon":"CaseStudyFilterOption_Icon__2VGKZ","CheckMark":"CaseStudyFilterOption_CheckMark__xol8j"};